/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { MaintenanceApiService } from './services/maintenance-api.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    MaintenanceApiService,
    ApiConfiguration
  ],
})
export class MaintenanceApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<MaintenanceApiModule> {
    return {
      ngModule: MaintenanceApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: MaintenanceApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('MaintenanceApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
